jQuery( document ).ready( function( $ ) {

    $( '.listing-gallery-inner' ).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
        prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
    });

    const fixStickyHeight = () => {
        // let left = $( '.listing-left' ).height();
        let form = $( '.contact-form-box' ).outerHeight();
        let bottom_space = form + 60;
        $( '.sticky-container' ).height( 'calc(100% - ' + bottom_space + 'px)' );
    }
    
    fixStickyHeight();
    $( window ).resize( fixStickyHeight );

    let name = $( 'h1' ).eq(0).text();
    $( '#input_2_7' ).val( name );

});